import { cn } from "@/lib/utils"

interface BorderBeamProps {
  /** Länge des Lichtstreifens; größer heißt längerer Schweif */
  size?: number
  /** Dauer einer Umrundung in Sekunden */
  duration?: number
  /** Startversatz in Sekunden */
  delay?: number
  colorFrom?: string
  colorTo?: string
  className?: string
  reverse?: boolean
  borderWidth?: number
}

/**
 * Umlaufender Lichtstreifen auf dem Rand. Ein Farbkegel dreht sich per transform unter
 * einer Maske, die nur den Rand freilässt. Das läuft komplett auf dem Compositor und
 * braucht keine Animationsbibliothek.
 */
export const BorderBeam = ({
  className,
  size = 50,
  delay = 0,
  duration = 6,
  colorFrom = "#ffaa40",
  colorTo = "#9c40ff",
  reverse = false,
  borderWidth = 1,
}: BorderBeamProps) => {
  // size (px) grob in einen Winkelanteil übersetzen: 160 px ≈ 16 % des Umfangs
  const schweif = Math.min(0.3, Math.max(0.06, size / 1000))
  return (
    <div
      className="pointer-events-none motion-reduce:hidden absolute inset-0 overflow-hidden rounded-[inherit] border-(length:--border-beam-width) border-transparent mask-[linear-gradient(transparent,transparent),linear-gradient(#000,#000)] mask-intersect [mask-clip:padding-box,border-box] [container-type:size]"
      style={{ "--border-beam-width": `${borderWidth}px` } as React.CSSProperties}
      aria-hidden="true"
    >
      <div
        className={cn("border-beam-spin absolute left-1/2 top-1/2 aspect-square", className)}
        style={
          {
            width: "calc(2 * max(100cqw, 100cqh))",
            backgroundImage: `conic-gradient(from 0turn, transparent ${1 - schweif}turn, ${colorTo} ${1 - schweif / 3}turn, ${colorFrom} 1turn)`,
            animationDuration: `${duration}s`,
            animationDelay: `${-delay}s`,
            animationDirection: reverse ? "reverse" : "normal",
          } as React.CSSProperties
        }
      />
    </div>
  )
}
